const passwordValidation = (currentPassword) => {
    return typeof currentPassword === "string" && currentPassword.length >= 8;
};
export { passwordValidation };
